<template>
  <div data-testid="app-menu" class="d-flex flex-column pb-0 all-height">
    <div data-testid="app-menu__scroller" class="scroller all-height">
      <div data-testid="app-menu__sidebar" class="menu-sidebar all-height">
        <v-list data-testid="app-menu__main-list" class="d-flex flex-column justify-space-between all-height pa-0">
          <div data-testid="app-menu__menu-section" class="d-flex flex-column menu-scroll-section gap-2">
            <!-- Shortcuts fly-out pinned at top -->
            <v-menu
              data-testid="app-menu__shortcuts-menu"
              v-if="hasShortcuts"
              v-model="shortcutsMenu"
              offset-x
              :nudge-right="0"
              :close-on-content-click="false"
              :open-delay="hoverOpenDelay"
              :close-delay="hoverCloseDelay"
              transition="fade-transition"
              :content-class="'shortcuts-menu ' + menuContentClass"
              open-on-hover
            >
              <template #activator="{ on, attrs }">
                <v-list-item
                  data-testid="app-menu__shortcuts-activator"
                  class="d-flex align-center nav-standard-item cursor-pointer menu-trigger-item"
                  :class="shortcutsMenu ? 'radius-small selected-menu-item' : ''"
                  v-bind="attrs"
                  v-on="on"
                  aria-label="Shortcuts"
                >
                  <template v-if="mini">
                    <v-tooltip data-testid="app-menu__shortcuts-tooltip" right content-class="tooltip-right">
                      <template #activator="{ on: ton, attrs: tattrs }">
                        <div data-testid="app-menu__shortcuts-icon-wrapper" class="d-flex align-center justify-center w-100" v-bind="tattrs" v-on="ton">
                          <img data-testid="app-menu__shortcuts-icon" src="/img/navicon/Shortcuts.svg" class="nav-img-icon" alt="Shortcuts icon" />
                        </div>
                      </template>
                      <span data-testid="app-menu__shortcuts-tooltip-text">Shortcuts</span>
                    </v-tooltip>
                  </template>
                  <template v-else>
                    <v-list-item-icon data-testid="app-menu__shortcuts-icon-wrapper" class="mr-2 ma-0 d-flex align-center justify-center">
                      <img data-testid="app-menu__shortcuts-icon" src="/img/navicon/Shortcuts.svg" class="nav-img-icon" alt="Shortcuts icon" />
                    </v-list-item-icon>
                    <v-list-item-content data-testid="app-menu__shortcuts-content" class="pa-0 d-flex align-center justify-start">
                      <v-list-item-title data-testid="app-menu__shortcuts-title" class="side-nav-text-color hide-when-mini text-truncate">Shortcuts</v-list-item-title>
                    </v-list-item-content>
                    <img src="/img/navicon/LeftArrow.svg" v-if="!mini" class="left-arrow-icon" alt="Left arrow for Shortcuts"/>
                  </template>
                </v-list-item>
              </template>
              <v-card data-testid="app-menu__shortcuts-card" class="fcmasters-menu-card">
                <h5 class="Menu-title mb-1 font-weight-medium" v-if="mini">Shortcuts</h5>
                <shortcuts-menu
                  ref="shortcutsMenuComponent"
                  :mini="mini"
                  component="appmenu"
                  @shortcut-click="handleShortcutFlyoutClick"
                  @shortcut-added="handleShortcutAdded"
                  @shortcut-removed="handleShortcutRemoved"
                />
              </v-card>
            </v-menu>
            <v-list-item-group data-testid="app-menu__item-group" active-class="">
              <div data-testid="app-menu__slide-group" class="d-flex flex-column gap-1 appmenu-slide-group">
                <!-- Single pass preserving original order -->
                <div data-testid="app-menu__item" v-for="{ idx, item } in displayItems" :key="'it-'+idx">
                  <!-- Header fly-out -->
                  <v-menu
                    data-testid="app-menu__header-menu"
                    v-if="item.header"
                    v-model="headerMenus['hdr_'+idx+'_'+item.title]"
                    offset-x
                    :nudge-right="0"
                    :close-on-content-click="true"
                    :open-delay="hoverOpenDelay"
                    :close-delay="hoverCloseDelay"
                    transition="fade-transition"
                    :content-class="'admin-header-menu ' + menuContentClass"
                    open-on-hover
                  >
                    <template #activator="{ on, attrs }">
                        <div
                          data-testid="app-menu__header-activator"
                          :class="['admin-header-row','nav-standard-item','py-3','pl-4','pr-4','d-flex','align-center','cursor-pointer', { 'v-list-item--active': isHeaderActive(idx) }]"
                          v-bind="attrs" v-on="on"
                          :aria-label="mini ? item.title : null"
                        >
                        <template v-if="mini">
                          <v-tooltip data-testid="app-menu__header-tooltip" right content-class="tooltip-right">
                            <template #activator="{ on: ton, attrs: tattrs }">
                              <div data-testid="app-menu__header-icon-wrapper" class="d-flex align-center justify-center w-100" v-bind="tattrs" v-on="ton">
                                <v-list-item-title data-testid="app-menu__header-mdi-icon" v-if="isMdi(headerIndexToGroup[idx].icon)"><v-icon class="side-nav-text-color">{{ headerIndexToGroup[idx].icon }}</v-icon></v-list-item-title>
                                <v-list-item-title data-testid="app-menu__header-img-icon" class="d-flex align-center" v-else-if="isImg(headerIndexToGroup[idx].icon)"><img :src="headerIndexToGroup[idx].icon" class="nav-img-icon" :alt="item.title + ' icon'" /></v-list-item-title>
                              </div>
                            </template>
                            <v-list-item-title data-testid="app-menu__header-title">{{ item.title }}</v-list-item-title>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-list-item-title data-testid="app-menu__header-mdi-icon" class="pr-2 flex-none" v-if="isMdi(headerIndexToGroup[idx].icon)"><v-icon class="side-nav-text-color">{{ headerIndexToGroup[idx].icon }}</v-icon></v-list-item-title>
                          <v-list-item-title data-testid="app-menu__header-img-icon" class="pr-2 flex-none d-flex align-center" v-else-if="isImg(headerIndexToGroup[idx].icon)"><img :src="headerIndexToGroup[idx].icon" class="nav-img-icon" :alt="item.title + ' icon'" /></v-list-item-title>
                          <v-list-item-title data-testid="app-menu__header-title" class="text-truncate side-nav-text-color hide-when-mini">{{ item.title }}</v-list-item-title>
                          <img src="/img/navicon/LeftArrow.svg" v-if="!mini" class="left-arrow-icon" alt="Left arrow for FC Masters"/>
                        </template>
                      </div>
                    </template>
                    <v-card data-testid="app-menu__header-card" flat class="pa-0 admin-header-card">
                      <h5 class="Menu-title mb-1 font-weight-medium" v-if="mini">{{ item.title }}</h5>
                      <v-list data-testid="app-menu__header-child-list" class="d-flex gap-1 flex-column pa-0">
                        <v-list-item
                          data-testid="app-menu__header-child-item"
                          v-for="child in headerIndexToGroup[idx].items"
                          :key="'hdr-'+idx+'-'+child.title"
                          :to="$nova.gotoLink({ path: child.href, hash: child.hash }, true)"
                          link
                          class="admin-child-item nav-standard-item d-block"
                          @click.stop="emitSelected(child.title); headerMenus['hdr_'+idx+'_'+item.title]=false"
                          :aria-label="mini ? child.title : null"
                        >
                          <template v-if="mini">
                            <div data-testid="app-menu__child-content" class="d-flex align-center black--text justify-space-between">
                              <template v-if="isMdi(child.icon)"><v-icon class="nav-icon side-nav-text-color text--darken-3 pa-1 mr-2">{{ child.icon }}</v-icon></template>
                              <template v-else-if="isImg(child.icon)"><img :src="child.icon" class="nav-img-icon" :alt="child.title + ' icon'" /></template>
                              <v-list-item-title data-testid="app-menu__child-title" class="app-menu-child-title">{{ child.title }}</v-list-item-title>
                            </div>
                          </template>
                          <template v-else>
                            <div data-testid="app-menu__child-content" class="d-flex align-center black--text  justify-space-between">
                              <template v-if="isMdi(child.icon)"><v-icon class="nav-icon side-nav-text-color text--darken-3 pa-1 mr-2">{{ child.icon }}</v-icon></template>
                              <template v-else-if="isImg(child.icon)"><img :src="child.icon" class="nav-img-icon" :alt="child.title + ' icon'" /></template>
                              <v-list-item-title data-testid="app-menu__child-title" class="app-menu-child-title">{{ child.title }}</v-list-item-title>
                              <shortcut-icon
                                v-if="fbcShortcutEnabled"
                                class="ml-2"
                                :item="child"
                                component="appmenu"
                                :loading="isShortcutLoading(child)"
                                :show-tooltip="false"
                                @add-shortcut="handleAddShortcut"
                              />
                            </div>
                          </template>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-menu>
                  <!-- Standalone item (not header, not grouped child) -->
                  <v-list-item
                    data-testid="app-menu__standalone-item"
                    v-else
                    :class="`nav-standard-item ${mini ? 'text-center' : 'sb-link-slide'} sb-link`"
                    :to="$nova.gotoLink({ path: item.href, hash: item.hash }, true)"
                    transition="scroll-x-transition"
                    @click.stop="emitSelected(item.title || item.name || item.href)"
                    :aria-label="mini ? (item.title || item.name) : null"
                  >
                    <template v-if="mini">
                      <v-tooltip data-testid="app-menu__standalone-tooltip" right content-class="tooltip-right">
                        <template #activator="{ on, attrs }">
                          <div data-testid="app-menu__standalone-icon-wrapper" class="black--text d-flex align-center justify-center w-100" v-bind="attrs" v-on="on">
                            <template v-if="isMdi(item.icon)"><v-icon data-testid="app-menu__standalone-mdi-icon" class="side-nav-text-color">{{ item.icon }}</v-icon></template>
                            <template v-else-if="isImg(item.icon)"><img data-testid="app-menu__standalone-img-icon" :src="item.icon" class="nav-img-icon side-nav-text-color" :alt="(item.title||item.name) + ' icon'" /></template>
                          </div>
                        </template>
                        <span data-testid="app-menu__standalone-tooltip-text">{{ item.title || item.name }}</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <div data-testid="app-menu__standalone-content" class="d-flex align-center justify-space-between all-width">
                        <div class="d-flex align-center">
                          <v-list-item-title data-testid="app-menu__standalone-mdi-icon" v-if="isMdi(item.icon)"><v-icon class="nav-icon side-nav-text-color">{{ item.icon }}</v-icon></v-list-item-title>
                          <v-list-item-title data-testid="app-menu__standalone-img-icon" class="d-flex align-center" v-else-if="isImg(item.icon)"><img :src="item.icon" class="nav-img-icon" :alt="(item.title||item.name) + ' icon'" /></v-list-item-title>
                          <v-list-item-title data-testid="app-menu__standalone-title" class="hide-when-mini side-nav-text-color flex-none pl-2">{{ item.title || item.name }}</v-list-item-title>
                        </div>
                      </div>
                    </template>
                  </v-list-item>
                </div>
              </div>
            </v-list-item-group>
          </div>
          <!-- Bottom utilities: Profile + Help & Support -->
          <div data-testid="app-menu__bottom-utilities" class="d-flex flex-column gap-1">
            <!-- Chatbot menu item -->
            <chatbot-menu-item
              v-if="chatbotEnabled"
              :mini="mini"
              :use-drawer="true"
              test-id-prefix="app-menu"
              extra-classes="menu-trigger-item"
              :active="selectedItem === 'chatbot'"
              label-tag="p"
              label-class="hide-when-mini pl-2 side-nav-text-color"
              @click="toggleChatbot"
            />

            <support-menu-item
              v-if="showManuals"
              :mini="mini"
              :use-widget="true"
              label="Manuals"
              icon-src="/img/icons/ManualsIcon.svg"
              icon-alt="Product manuals"
              aria-label="Product manuals"
              test-id-prefix="app-menu-manuals"
              extra-classes="menu-trigger-item"
              :active="isManualsActive"
              active-class="radius-small selected-menu-item"
              label-tag="p"
              label-class="hide-when-mini pl-2 side-nav-text-color"
              @click="openManuals"
            />

            <!-- Help & Support (always show for non financial close) -->
            <support-menu-item
              v-if="fdSupportWidget"
              :mini="mini"
              :use-widget="true"
              test-id-prefix="app-menu"
              :extra-classes="'menu-trigger-item'"
              :aria-label="'Help & Support'"
              label-tag="p"
              label-class="hide-when-mini pl-2 side-nav-text-color"
              @click="openFDSupport"
            />

            <!-- Profile menu -->
            <profile-menu-flyout
              v-model="profileMenu"
              :mini="mini"
              :hover-close-delay="hoverCloseDelay"
              :close-on-content-click="true"
              activator-extra-class="flex-none"
              activator-aria-label="Profile menu"
              open-on-click
              test-id-prefix="app-menu"
              @edit-profile="$emit('edit-profile')"
            />

            <!-- Subscriptions fly-out (mirrors FinancialClose) -->
            <subscriptions-menu-flyout
              v-model="subscriptionsMenu"
              :mini="mini"
              :hover-close-delay="hoverCloseDelay"
              :close-on-content-click="true"
              activator-aria-label="Subscriptions"
              activator-active-class="caccounting--text radius-small selected-caccounting"
              label="Apps"
              icon-alt="Subscriptions"
              :applist="applist"
              :is-app-active="isAppActive"
              label-class="text-capitalize text-truncate"
              selected-item-class="caccounting--text radius-small selected-caccounting"
              :show-shortcut-icon="fbcShortcutEnabled"
              :shortcut-loading-fn="isShortcutLoading"
              shortcut-icon-class="ml-2 shortcut-icon"
              shortcut-icon-alt="Add Shortcut"
              test-id-prefix="app-menu"
              @app-click="handleAppClick"
              @add-shortcut="handleSubscriptionsShortcut"
            />

          </div>
        </v-list>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileMenuFlyout from './navigation/ProfileMenuFlyout.vue';
import SubscriptionsMenuFlyout from './navigation/SubscriptionsMenuFlyout.vue';
import SupportMenuItem from './navigation/SupportMenuItem.vue';
import ChatbotMenuItem from './navigation/ChatbotMenuItem.vue';
import ShortcutIcon from './FinancialClose/ShortcutIcon.vue';

export default {
  name: 'AppMenu',
  components: {
    ProfileMenuFlyout,
    SubscriptionsMenuFlyout,
    SupportMenuItem,
    ChatbotMenuItem,
    ShortcutIcon,
    ShortcutsMenu: () => import('./FinancialClose/ShortcutsMenu.vue')
  },
  props: {
    mini: { type: Boolean, default: false },
    menu: { type: Array, default: () => [] },
    selectedItem: { type: String, default: null },
    openMenu: { type: Boolean, default: false },
    applist: { type: Array, default: () => [] },
    fdSupportWidget: { type: Boolean, default: false },
    chatbotEnabled: { type: Boolean, default: false },
    showManuals: { type: Boolean, default: false },
  },
  emits: ['update:selectedItem', 'update:openMenu', 'logout', 'edit-profile', 'manuals-click'],
  data() {
    return {
      profileMenu: false,
      headerMenus: {},
      subscriptionsMenu: false,
      selectedAppKey: null,
      shortcutPendingName: null,
      shortcutsMenu: false
    };
  },
  computed: {
    isManualsActive() {
      return this.$constants.isManualsPath(this.$route.path || '');
    },
    hoverOpenDelay() {
      const config = this.$constants.STYLES.SIDE_NAV;
      return this.mini ? config.COLLAPSED.OPEN_DELAY : config.EXPANDED.OPEN_DELAY;
    },
    hoverCloseDelay() {
      const config = this.$constants.STYLES.SIDE_NAV;
      return this.mini ? config.COLLAPSED.CLOSE_DELAY : config.EXPANDED.CLOSE_DELAY;
    },
    menuContentClass() {
      return this.mini ? 'nav-menu-collapsed' : 'nav-menu-expanded';
    },
    componentKey() {
      return 'appmenu';
    },
    headerGroups() {
      const groups = [];
      
      for (let i = 0; i < this.menu.length; i++) {
        const item = this.menu[i];
        if (!item?.header) continue;
        
        const headerKey = `hdr_${i}_${item.title}`;
        const children = [];
        
        // Collect children until next header
        let j = i + 1;
        while (j < this.menu.length && !this.menu[j].header) {
          if (this.menu[j].href) {
            if (!this.menu[j].aiEnabled || this.$store.state.aiEnabled) {
              children.push(this.menu[j]);
            }
          }
          j++;
        }
        
        const derivedIcon = item.icon || children[0]?.icon || null;
        groups.push({ headerKey, title: item.title, items: children, icon: derivedIcon });
        
        // Initialize header menu state
        if (this.headerMenus[headerKey] === undefined) {
          this.$set(this.headerMenus, headerKey, false);
        }
      }
      
      return groups;
    },
    
    headerIndexToGroup() {
      const map = {};
      this.headerGroups.forEach(group => {
        const idx = parseInt(group.headerKey.split('_')[1]);
        map[idx] = group;
      });
      return map;
    },
    
    groupChildIndexSet() {
      const set = new Set();
      
      for (let i = 0; i < this.menu.length; i++) {
        if (this.menu[i]?.header) {
          let j = i + 1;
          while (j < this.menu.length && !this.menu[j].header) {
            set.add(j);
            j++;
          }
        }
      }
      
      return set;
    },
    
    displayItems() {
      const items = [];
      
      for (let i = 0; i < this.menu.length; i++) {
        const item = this.menu[i];
        if (!item) continue;
        
        // Include headers
        if (item.header) {
          items.push({ idx: i, item });
          continue;
        }
        
        // Skip grouped children, products, and non-navigable items
        if (this.groupChildIndexSet.has(i)) continue;
        if (item.product) continue;
        if (!item.href) continue;
        if (item.aiEnabled && !this.$store.state.aiEnabled) continue;
        
        items.push({ idx: i, item });
      }
      
      return items;
    },

    hasShortcuts() {
      return this.fbcShortcutEnabled && this.$store.getters['shortcuts/hasShortcuts'](this.componentKey);
    },
    fbcShortcutEnabled() {
      return this.$store.state.pinCount !== -1;
    }
  },
  mounted() {
    if (this.fbcShortcutEnabled) {
      this.$store.dispatch('shortcuts/fetchShortcuts', { component: this.componentKey });
    }
  },
  methods: {
    emitSelected(name) {
      this.$root.closeFloatingComponents?.(name);
      this.$emit('update:selectedItem', name);
    },
    
    openManuals() {
      this.$emit('manuals-click');
    },
    openFDSupport() {
      this.$root.closeFloatingComponents?.();
      this.$emit('update:selectedItem', 'support');
      this.$root.openFDSupport?.();
    },
    
    toggleChatbot() {
      this.$emit('update:selectedItem', 'chatbot');
      this.$root.toggleChatbot?.();
    },
    
    isMdi(val) {
      return typeof val === 'string' && /^mdi[\s-]/.test(val);
    },
    
    isImg(val) {
      return typeof val === 'string' && /\.(svg|png|jpe?g|gif|webp)$/i.test(val);
    },
    
    toggleHeader(key) {
      this.headerMenus[key] = !this.headerMenus[key];
    },
    
    isHeaderActive(idx) {
      const group = this.headerIndexToGroup[idx];
      if (!group) return false;
      
      return group.items.some(child => 
        child.title === this.selectedItem || child.name === this.selectedItem
      );
    },
    
    isAppActive(app) {
      if (!app) return false;
      if (this.selectedAppKey === app.name) return true;
      
      try {
        const link = app.link?.replace(/\/$/, '');
        return link && this.$route.path.startsWith(link);
      } catch (e) {
        return false;
      }
    },
    
    handleAppClick(app) {
      if (!app) return;
      this.$root.closeFloatingComponents?.();
      this.selectedAppKey = app.name;
      try {
        this.$nova.gotoLink({ path: app.link });
      } catch (e) {
        // Navigation failure is non-fatal
      }
      this.subscriptionsMenu = false;
    },

    isShortcutLoading(item) {
      const name = item?.name || item?.title || item?.displayname || null;
      if (!name) return false;
      return this.shortcutPendingName === name;
    },

    async handleAddShortcut(shortcutData) {
      if (!this.fbcShortcutEnabled) return false;

      const resolveRef = () => {
        const ref = this.$refs.shortcutsMenuComponent;
        return Array.isArray(ref) ? ref[0] : ref;
      };

      const shortcutsMenuInstance = resolveRef();

      const pendingName = shortcutData?.name || null;
      if (pendingName) {
        if (this.shortcutPendingName === pendingName) {
          return false;
        }
        this.shortcutPendingName = pendingName;
      }

      let result = false;

      if (shortcutsMenuInstance && typeof shortcutsMenuInstance.addShortcut === 'function') {
        try {
          result = await shortcutsMenuInstance.addShortcut(shortcutData);
        } finally {
          if (pendingName && this.shortcutPendingName === pendingName) {
            this.shortcutPendingName = null;
          }
        }
        return result;
      }

      try {
        const storeResult = await this.$store.dispatch('shortcuts/addShortcut', {
          component: this.componentKey,
          shortcut: {
            name: shortcutData.name,
            url: shortcutData.url,
            meta: shortcutData.meta || {}
          }
        });

        const message = storeResult?.message || 'Failed to add shortcut.';

        if (storeResult?.type === 'success') {
          this.$store?.commit?.('sbSuccess', message);
          this.$toast?.success?.(message);
          result = true;
        } else if (storeResult?.type === 'warning') {
          this.$store?.commit?.('sbWarning', message);
          this.$toast?.warning?.(message);
        } else if (storeResult?.type === 'info') {
          this.$store?.commit?.('sbInfo', message);
          this.$toast?.info?.(message);
        } else {
          this.$store?.commit?.('sbError', message);
          this.$toast?.error?.(message);
        }
      } catch (error) {
        console.error('Failed to add shortcut:', error);
        const message = error.response?.data?.message || 'Failed to add shortcut.';
        this.$store?.commit?.('sbError', message);
        this.$toast?.error?.(message);
        result = false;
      } finally {
        if (pendingName && this.shortcutPendingName === pendingName) {
          this.shortcutPendingName = null;
        }
      }

      return result;
    },

    handleSubscriptionsShortcut(app) {
      if (!app) return;
      const name = app.displayname || app.name;
      if (!name) return;

      this.handleAddShortcut({
        name,
        url: app.link,
        meta: { ...(app.meta || {}), component: 'appmenu' }
      });
    },

    handleShortcutFlyoutClick(shortcut) {
      this.shortcutsMenu = false;
      if (shortcut?.name) {
        this.emitSelected(shortcut.name);
      }
    },

    async handleShortcutAdded() {
      this.shortcutsMenu = false;
    },

    async handleShortcutRemoved() {
      if (!this.hasShortcuts) {
        this.shortcutsMenu = false;
      }
    }
  },
  watch: {
    hasShortcuts(value) {
      if (!value) {
        this.shortcutsMenu = false;
      }
    },
    '$route.path': {
      immediate: true,
      handler(path) {
        if (this.shortcutsMenu) {
          this.shortcutsMenu = false;
        }
        if (!this.applist?.length) return;
        
        const found = this.applist.find(app => {
          const link = app.link?.replace(/\/$/, '');
          return link && path.startsWith(link);
        });
        
        if (found) {
          this.selectedAppKey = found.name;
        }
      }
    }
  }
};
</script>

<style scoped>
/* Component-specific minimal overrides (structural only) */
.menu-scroll-section { overflow-y:auto; overscroll-behavior:contain; }
/* Duplicate minimal flyout styling since SASS @extend not available in plain scoped block */
.admin-header-menu { padding:16px 8px; min-width: 200px !important; }
.admin-header-menu .v-list, .admin-header-menu .v-card { background:transparent; }
.admin-header-card { box-shadow:none; background:transparent; }
.admin-child-item.v-list-item--active { background: var(--color-hover-bg); color: var(--color-active-text) !important; }
.admin-child-item.v-list-item--active .app-menu-child-title { color: var(--color-active-text) !important; }
.v-list-item:hover .shortcut-icon { opacity: 1; }
.shortcut-icon {
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s ease;
  margin-left: 8px;
}
.shortcut-icon:hover {
  opacity: 1;
  transform: scale(1.1);
}
.shortcut-icon--active {
  opacity: 1;
  filter: brightness(1.2);
}
</style>
